export const flag = () => {
  return (
    <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M3.5 13.125C3.5 13.125 4.375 12.25 7 12.25C9.625 12.25 11.375 14 14 14C16.625 14 17.5 13.125 17.5 13.125V2.625C17.5 2.625 16.625 3.5 14 3.5C11.375 3.5 9.625 1.75 7 1.75C4.375 1.75 3.5 2.625 3.5 2.625V13.125Z'
        stroke='#1F1F24'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path d='M3.5 19.25V13.125' stroke='#1F1F24' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
    </svg>
  );
};
